import { relative } from "node:path";
import { Component } from "projen";
import { TypeScriptProject } from "projen/lib/typescript";
import { ensureRelativePathStartsWithDot } from "projen/lib/util/path";

/*******************************************************************************
 *
 * Update / customize typescript configs for a project.
 *
 * Update typescript paths in tsconfig so we don't have to compile packages to
 * dist in order to see changes.
 *
 ******************************************************************************/
export class TypeScriptConfig extends Component {
  constructor(project: TypeScriptProject) {
    super(project);

    /**
     * Container for paths to insert at the end.
     */
    let tsPaths = {};

    const workspaceDeps = project.deps.all.filter(
      (d) => d.version === "workspace:*",
    );

    workspaceDeps.forEach((dep) => {
      const subproject = (
        project.root.subprojects as Array<TypeScriptProject>
      ).find((p) => p.package.packageName === dep.name);

      if (!subproject) {
        throw new Error(`Could not find subproject ${dep.name} in monorepo.`);
      }

      tsPaths = {
        ...tsPaths,
        [dep.name]: [
          ensureRelativePathStartsWithDot(
            relative(project.outdir, subproject.outdir),
          ),
        ],
      };
    });

    project.tsconfig?.file.addOverride("compilerOptions.paths", tsPaths);
    project.tsconfigDev?.file.addOverride("compilerOptions.paths", tsPaths);
  }
}
